<!--<div class="row" *ngIf="ShowList">
  <div class="col-md-12 S1 padding-right-0px background-white ">
    <div class="card">

      <div class="card-body background-white">
        <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px">

          <div class="row">



            <div class="column6">
              <div class="card background-white">

                <div class="card-header wh-header header3 padding-right-32px  padding-top-0px">
                  <div class="row margin-left-10px nav-link-hand">

                    <label class="wh-header font-weight-normal border-radius-4px padding-top-10px padding-bottom-4px margin-bottom-0px">
                      Code Types
                    </label>


                  </div>

                </div>
                <div class="card-body padding-top-0px padding-left-0px padding-right-0px">
                  <div class="row border-top border-bottom padding-top-10px padding-bottom-10px margin-right-0px margin-left16px">
                    <input type="search" class="form-control padding-bottom-2px width-176px margin-left-10px" placeholder="Search....">
                    <div class="col-md-2 padding-top-2px padding-left-10px">
                      <button type="button" (click)="newmodal1()" class="btn btn-new btn-sm" tooltip="Add"><i class="fas fa-plus nav-link-hand"></i></button>

                    </div>

                  </div>
                  <div>
                    <div class="chatsd product-chart-wrapper product-chat-width-90 agreement-chart-wrapper ps2 padding-lrt ">
                      <div class="row border-bottom rowfor margin-left16px nav-link-hand margin-right-0px">
                        <div class="col-md-12">

                          <a class="nav-link-hand margin-left-5px font-size-14" (click)="viewservice()">Institute type</a>

                        </div>
                      </div>

                      <div class="row border-bottom rowfor margin-left16px nav-link-hand margin-right-0px">
                        <div class="col-md-12">

                          <a class="nav-link-hand margin-left-5px font-size-14" (click)="viewservice()">Actor</a>

                        </div>
                      </div>

                      <div class="row border-bottom rowfor margin-left16px nav-link-hand margin-right-0px">
                        <div class="col-md-12">

                          <a class="nav-link-hand margin-left-5px font-size-14" (click)="viewservice()">Institute type</a>

                        </div>
                      </div>

                      <div class="row border-bottom rowfor margin-left16px nav-link-hand margin-right-0px">
                        <div class="col-md-12">

                          <a class="nav-link-hand margin-left-5px font-size-14" (click)="viewservice()">Actor</a>

                        </div>
                      </div>

                      <div class="row border-bottom rowfor margin-left16px nav-link-hand margin-right-0px">
                        <div class="col-md-12">

                          <a class="nav-link-hand margin-left-5px font-size-14" (click)="viewservice()">Institute type</a>

                        </div>
                      </div>

                      <div class="row border-bottom rowfor margin-left16px nav-link-hand margin-right-0px">
                        <div class="col-md-12">

                          <a class="nav-link-hand margin-left-5px font-size-14" (click)="viewservice()">Actor</a>

                        </div>
                      </div>

                      <div class="row border-bottom rowfor margin-left16px nav-link-hand margin-right-0px">
                        <div class="col-md-12">

                          <a class="nav-link-hand margin-left-5px font-size-14" (click)="viewservice()">Institute type</a>

                        </div>
                      </div>

                      <div class="row border-bottom rowfor margin-left16px nav-link-hand margin-right-0px">
                        <div class="col-md-12">

                          <a class="nav-link-hand margin-left-5px font-size-14" (click)="viewservice()">Actor</a>

                        </div>
                      </div>

                      <div class="row border-bottom rowfor margin-left16px nav-link-hand margin-right-0px">
                        <div class="col-md-12">

                          <a class="nav-link-hand margin-left-5px font-size-14" (click)="viewservice()">Institute type</a>

                        </div>
                      </div>

                      <div class="row border-bottom rowfor margin-left16px nav-link-hand margin-right-0px">
                        <div class="col-md-12">

                          <a class="nav-link-hand margin-left-5px font-size-14" (click)="viewservice()">Actor</a>

                        </div>
                      </div>

                      <div class="row border-bottom rowfor margin-left16px nav-link-hand margin-right-0px">
                        <div class="col-md-12">

                          <a class="nav-link-hand margin-left-5px font-size-14" (click)="viewservice()">Institute type</a>

                        </div>
                      </div>

                      <div class="row border-bottom rowfor margin-left16px nav-link-hand margin-right-0px">
                        <div class="col-md-12">

                          <a class="nav-link-hand margin-left-5px font-size-14" (click)="viewservice()">Actor</a>

                        </div>
                      </div>

                      <div class="row border-bottom rowfor margin-left16px nav-link-hand margin-right-0px">
                        <div class="col-md-12">

                          <a class="nav-link-hand margin-left-5px font-size-14" (click)="viewservice()">Institute type</a>

                        </div>
                      </div>

                      <div class="row border-bottom rowfor margin-left16px nav-link-hand margin-right-0px">
                        <div class="col-md-12">

                          <a class="nav-link-hand margin-left-5px font-size-14" (click)="viewservice()">Actor</a>

                        </div>
                      </div>

                      <div class="row border-bottom rowfor margin-left16px nav-link-hand margin-right-0px">
                        <div class="col-md-12">

                          <a class="nav-link-hand margin-left-5px font-size-14" (click)="viewservice()">Institute type</a>

                        </div>
                      </div>

                      <div class="row border-bottom rowfor margin-left16px nav-link-hand margin-right-0px">
                        <div class="col-md-12">

                          <a class="nav-link-hand margin-left-5px font-size-14" (click)="viewservice()">Actor</a>

                        </div>
                      </div>

                      <div class="row border-bottom rowfor margin-left16px nav-link-hand margin-right-0px">
                        <div class="col-md-12">

                          <a class="nav-link-hand margin-left-5px font-size-14" (click)="viewservice()">Institute type</a>

                        </div>
                      </div>

                      <div class="row border-bottom rowfor margin-left16px nav-link-hand margin-right-0px">
                        <div class="col-md-12">

                          <a class="nav-link-hand margin-left-5px font-size-14" (click)="viewservice()">Actor</a>

                        </div>
                      </div>

                      <div class="row border-bottom rowfor margin-left16px nav-link-hand margin-right-0px">
                        <div class="col-md-12">

                          <a class="nav-link-hand margin-left-5px font-size-14" (click)="viewservice()">Institute type</a>

                        </div>
                      </div>

                      <div class="row border-bottom rowfor margin-left16px nav-link-hand margin-right-0px">
                        <div class="col-md-12">

                          <a class="nav-link-hand margin-left-5px font-size-14" (click)="viewservice()">Actor</a>

                        </div>
                      </div>

                      <div class="row border-bottom rowfor margin-left16px nav-link-hand margin-right-0px">
                        <div class="col-md-12">

                          <a class="nav-link-hand margin-left-5px font-size-14" (click)="viewservice()">Institute type</a>

                        </div>
                      </div>

                      <div class="row border-bottom rowfor margin-left16px nav-link-hand margin-right-0px">
                        <div class="col-md-12">

                          <a class="nav-link-hand margin-left-5px font-size-14" (click)="viewservice()">Actor</a>

                        </div>
                      </div>

                      <div class="row border-bottom rowfor margin-left16px nav-link-hand margin-right-0px">
                        <div class="col-md-12">

                          <a class="nav-link-hand margin-left-5px font-size-14" (click)="viewservice()">Institute type</a>

                        </div>
                      </div>

                      <div class="row border-bottom rowfor margin-left16px nav-link-hand margin-right-0px">
                        <div class="col-md-12">

                          <a class="nav-link-hand margin-left-5px font-size-14" (click)="viewservice()">Actor</a>

                        </div>
                      </div>

                    </div>
                  </div>

                </div>

              </div>
            </div>

            <div class="column7" *ngIf="ShowService1"></div>

            <div class="column-codedtype margin-left-18" *ngIf="ShowService">

              <div class="row margin-top-7px">
                <div class="col-md-12 padding-left-0px">
                  <div class="">
                    <div class="card">
                      <div class="card-header wh-header border-bottom padding-top-0px">
                        <div class="row">

                          <div class="col-md-12 padding-left-0px">
                            <div class="row margin-left-zero margin-right-0px">


                              <div class="col-md-12 padding-right-0px padding-left-0px margin-right-8p">
                                <div class="row">
                                  <div class="col-md-12 padding-right-0px">
                                    <input type="search" class="form-control padding-bottom-2px width-176px margin-left-10px float-right" placeholder="Search....">
                                    <label class="float-left">
                                      Institute type
                                    </label>
                                  </div>

                                </div>

                              </div>

                            </div>
                          </div>

                        </div>
                      </div>
                      <div class="card-body">
                        <div class="chatsd product-chart-wrapper product-chat-width-102 agreement-chart-wrapper ps2 padding-lrt ">
                          <div class="table-component b1">
                            <div class="table-responsive overflow-x-hidden">


                              <table class="table table-striped margin-left-zero">

                                <thead>
                                  <tr>
                                    <th>Long Value</th>

                                    <th>Short Value</th>

                                    <th> </th>

                                  </tr>
                                </thead>
                                <tbody class="datatable-body">
                                  <tr>
                                    <td class="f3">Associate degree</td>
                                    <td class="f3">Associate degree</td>
                                    <td><a (click)="editmodal()"> <i class="fas fa-pencil-alt margin-right-10px nav-link-hand"></i></a> <i class="fas fa-trash margin-left-5px"></i></td>


                                  </tr>

                                  <tr>
                                    <td class="f3">Associate degree</td>
                                    <td class="f3">Associate degree</td>
                                    <td><a (click)="editmodal()"><i class="fas fa-pencil-alt margin-right-10px nav-link-hand"></i></a> <i class="fas fa-trash margin-left-5px"></i></td>


                                  </tr>

                                  <tr>
                                    <td class="f3">Associate degree</td>
                                    <td class="f3">Associate degree</td>
                                    <td><a (click)="editmodal()"><i class="fas fa-pencil-alt margin-right-10px nav-link-hand"></i></a> <i class="fas fa-trash margin-left-5px"></i></td>


                                  </tr>

                                  <tr>
                                    <td class="f3">Associate degree</td>
                                    <td class="f3">Associate degree</td>
                                    <td><a (click)="editmodal()"><i class="fas fa-pencil-alt margin-right-10px nav-link-hand"></i></a> <i class="fas fa-trash margin-left-5px"></i></td>


                                  </tr>

                                  <tr>
                                    <td class="f3">Associate degree</td>
                                    <td class="f3">Associate degree</td>
                                    <td><a (click)="editmodal()"><i class="fas fa-pencil-alt margin-right-10px nav-link-hand"></i></a> <i class="fas fa-trash margin-left-5px"></i></td>


                                  </tr>

                                  <tr>
                                    <td class="f3">Associate degree</td>
                                    <td class="f3">Associate degree</td>
                                    <td><a (click)="editmodal()"> <i class="fas fa-pencil-alt margin-right-10px nav-link-hand"></i></a> <i class="fas fa-trash margin-left-5px"></i></td>


                                  </tr>

                                  <tr>
                                    <td class="f3">Associate degree</td>
                                    <td class="f3">Associate degree</td>
                                    <td><a (click)="editmodal()"><i class="fas fa-pencil-alt margin-right-10px nav-link-hand"></i></a> <i class="fas fa-trash margin-left-5px"></i></td>


                                  </tr>

                                  <tr>
                                    <td class="f3">Associate degree</td>
                                    <td class="f3">Associate degree</td>
                                    <td><a (click)="editmodal()"><i class="fas fa-pencil-alt margin-right-10px nav-link-hand"></i></a> <i class="fas fa-trash margin-left-5px"></i></td>


                                  </tr>

                                  <tr>
                                    <td class="f3">Associate degree</td>
                                    <td class="f3">Associate degree</td>
                                    <td><a (click)="editmodal()"><i class="fas fa-pencil-alt margin-right-10px nav-link-hand"></i></a> <i class="fas fa-trash margin-left-5px"></i></td>


                                  </tr>

                                  <tr>
                                    <td class="f3">Associate degree</td>
                                    <td class="f3">Associate degree</td>
                                    <td><a (click)="editmodal()"><i class="fas fa-pencil-alt margin-right-10px nav-link-hand"></i></a> <i class="fas fa-trash margin-left-5px"></i></td>


                                  </tr>

                                  <tr>
                                    <td class="f3">Associate degree</td>
                                    <td class="f3">Associate degree</td>
                                    <td><a (click)="editmodal()"> <i class="fas fa-pencil-alt margin-right-10px nav-link-hand"></i></a> <i class="fas fa-trash margin-left-5px"></i></td>


                                  </tr>

                                  <tr>
                                    <td class="f3">Associate degree</td>
                                    <td class="f3">Associate degree</td>
                                    <td><a (click)="editmodal()"><i class="fas fa-pencil-alt margin-right-10px nav-link-hand"></i></a> <i class="fas fa-trash margin-left-5px"></i></td>


                                  </tr>

                                  <tr>
                                    <td class="f3">Associate degree</td>
                                    <td class="f3">Associate degree</td>
                                    <td><a (click)="editmodal()"><i class="fas fa-pencil-alt margin-right-10px nav-link-hand"></i></a> <i class="fas fa-trash margin-left-5px"></i></td>


                                  </tr>

                                  <tr>
                                    <td class="f3">Associate degree</td>
                                    <td class="f3">Associate degree</td>
                                    <td><a (click)="editmodal()"><i class="fas fa-pencil-alt margin-right-10px nav-link-hand"></i></a> <i class="fas fa-trash margin-left-5px"></i></td>


                                  </tr>

                                  <tr>
                                    <td class="f3">Associate degree</td>
                                    <td class="f3">Associate degree</td>
                                    <td><a (click)="editmodal()"><i class="fas fa-pencil-alt margin-right-10px nav-link-hand"></i></a> <i class="fas fa-trash margin-left-5px"></i></td>


                                  </tr>

                                  <tr>
                                    <td class="f3">Associate degree</td>
                                    <td class="f3">Associate degree</td>
                                    <td><a (click)="editmodal()"> <i class="fas fa-pencil-alt margin-right-10px nav-link-hand"></i></a> <i class="fas fa-trash margin-left-5px"></i></td>


                                  </tr>

                                  <tr>
                                    <td class="f3">Associate degree</td>
                                    <td class="f3">Associate degree</td>
                                    <td><a (click)="editmodal()"><i class="fas fa-pencil-alt margin-right-10px nav-link-hand"></i></a> <i class="fas fa-trash margin-left-5px"></i></td>


                                  </tr>

                                  <tr>
                                    <td class="f3">Associate degree</td>
                                    <td class="f3">Associate degree</td>
                                    <td><a (click)="editmodal()"><i class="fas fa-pencil-alt margin-right-10px nav-link-hand"></i></a> <i class="fas fa-trash margin-left-5px"></i></td>


                                  </tr>

                                  <tr>
                                    <td class="f3">Associate degree</td>
                                    <td class="f3">Associate degree</td>
                                    <td><a (click)="editmodal()"><i class="fas fa-pencil-alt margin-right-10px nav-link-hand"></i></a> <i class="fas fa-trash margin-left-5px"></i></td>


                                  </tr>

                                  <tr>
                                    <td class="f3">Associate degree</td>
                                    <td class="f3">Associate degree</td>
                                    <td><a (click)="editmodal()"><i class="fas fa-pencil-alt margin-right-10px nav-link-hand"></i></a> <i class="fas fa-trash margin-left-5px"></i></td>


                                  </tr>


                                </tbody>

                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="column8">
              <div class="card">
                <div class="card-header background-white pad4">
                  <label class="title font-size-20px margin-top-0px margin-bottom-0px">Add Coded Values</label>

                </div>

                <div class="card-body">
                  <div class="row my-pro-form margin-t-form">
                    <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 text-align-right">
                          <label class="lab-size1"> Long Value </label>
                        </div>
                        <div class="col-md-6">

                          <input type="text" class="form-control form-control-patient font-size-20px" placeholder="Long Value">


                        </div>


                      </div>

                    </div>
                  </div>

                  <div class="row my-pro-form margin-t-form">
                    <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 text-align-right">
                          <label class="lab-size1"> Short Value </label>
                        </div>
                        <div class="col-md-6">

                          <input type="text" class="form-control form-control-patient font-size-20px" placeholder="Short Value">


                        </div>


                      </div>

                    </div>
                  </div>

                </div>
                <div class="row margin-top-15px margin-top-30px margin-bottom-30px">

                  <div class="col-md-8">
                    <button class="btn btn-primary hover1 nav-link-hand font-size-16px width float-right" type="button">Save</button>
                  </div>



                </div>
              </div>
            </div>





          </div>
        </div>










      </div>
          </div>


        </div>
      </div>-->



<div class="job-posts placements agreements margin-top-service-30px">
  <div class="card skillassest-form">




  </div>
  <div class="card-body padding-top padding-left-0px padding-right-0px">
    <div class="row">

      <div class="position-fixed-codetypes border-right2 padding-right-0px">
        <div class="card height-600px">

          <div class="card-header wh-header header3 padding-right-32px bk-color-light">
            <div class="row margin-top10px margin-left-20px card-title-schedule-bb">

              <label class="wh-header font-weight-normal card-title-schedule-bl2 border-radius-4px padding-top-10px padding-bottom-4px margin-bottom-0px bk-color-light">
                Coded Types
              </label>


            </div>



          </div>
          <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-light">

            <div class="row border-top border-bottom padding-top-10px padding-bottom-10px margin-right-0px margin-left-0px">
              <div class="col-md-9">
                <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                <!--<input type="search" class="form-control padding-bottom-2px  margin-left-10px" placeholder="Search....">-->
              </div>
              <div class="col-md-2 padding-top-2px padding-left-10px">
                <button type="button" (click)="newmodal1()" class="btn btn-new btn-sm" tooltip="Add"><i class="fas fa-plus nav-link-hand"></i></button>

              </div>

            </div>
            <div class="chatsd product-chart-wrapper product-chat-width-97 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
              <div class="row border-bottom  rowfor margin-left-zero margin-right-0px nav-link-hand padding-all-5px"  *ngFor="let l of pdata">
                <div class="col-md-12">
                  <div class="row height-20px margin-left-zero" (click)="viewcodedtypes(l)">

                    <a class="nav-link-hand margin-left-5px font-size-14 td-elipsis-scan" (click)="viewcodedtypes(l)">{{l.Name}}</a>
                  </div>


                </div>


              </div>
              </div>

            </div>

          </div>
      </div>

      <div class="offset-md-2 col-md-6 padding-left-0px padding-right-7px padding-left-2px">
        <div class="chatsd product-chart-wrapper agreement-chart-wrapper ps ps2 padding-lrt">
          <div class="card">
            <div class="row">

              <div class="col-md-12  padding-right-0px">
                <div class="card">
                  <div class="card-header wh-header card-title-schedule-bl2 font-weight-normal padding-top-6px padding-bottom-6px padding-left-5px card-title-schedule-bb">
                    <div class="row">
                      <div class="col-md-4" >

                        <label class="margin-bottom-0px" *ngIf="SelectedCodedType"> {{SelectedCodedType.Name}}</label>
                       
                      </div>
                      <div class="col-md-8">
                        <!--<input type="search" class="form-control padding-bottom-2px margin-left-10px float-right" placeholder="Search....">-->
                        <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange2($event)"></search-list>
                      </div>
                    </div>
                  </div>
                  <div class="card-body padding-top-0px">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="table-component">
                          <div class="table-responsive overflow-x">
                            <table class="table table-striped margin-left-zero"
                                   cols="auto,2*,*,*,*,*,*,*">
                              <thead class="">
                                <tr>
                                  <th class="">
                                    Long Value
                                  </th>
                                  <th class="">
                                    Short Value
                                  </th>
                                  <th class="">
                                  </th>
                                </tr>
                              </thead>
                              <tbody class="table-body">
                                <tr *ngFor="let l of pdata2">
                                  <td class="td-padding-tb td-border-8px-green"><label class="margin-left-3 margin-bottom-0px label-table-color">{{l.LongValue}}</label></td>
                                  <td class="td-padding-tb">{{l.ShortValue}}</td>
                                  <td class="td-padding-tb"><a (click)="editmodal(l)"><i class="fas fa-pencil-alt margin-right-10px nav-link-hand"></i></a> <a (click)="delcodetype(l)" title="Remove"><i class="fas fa-trash margin-left-5px nav-link-hand"></i></a></td>
                                </tr>
                              
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class=" col-md-4 padding-left-0px">
        <div class="card position-fixed-activity affix my-profile-form">
          <div class="card-header wh-header card-title-schedule-bl2 font-weight-normal padding-top-6px padding-bottom-6px padding-left-5px card-title-schedule-bb">
            Add Coded Values
          </div>
          <div class="card-body margin-left-zero padding-left-0px padding-right-0px">
            <form class="form " novalidate="" #f="ngForm" (ngSubmit)="onSubmit()">
              <div class="row margin-left-auto margin-bottom-10px">
                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                  <div class="row">
                    <div class="col-md-4 text-align-right margin-tg-auto ">
                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Long Value</label>
                    </div>
                    <div class="col-md-6">
                      <div class="date-form">
                        <input class="form-control" placeholder="Long Value"
                                id="CurrentSaveCodedValuesRequest.LongValue"
                         [(ngModel)]="CurrentSaveCodedValuesRequest.LongValue" required
                         name="CurrentSaveCodedValuesRequest.LongValue" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                         maxlength="100" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row margin-left-auto margin-bottom-10px">
                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                  <div class="row">
                    <div class="col-md-4 text-align-right margin-tg-auto ">
                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Short Value</label>
                    </div>
                    <div class="col-md-6">
                      <div class="date-form">
                        <input class="form-control" placeholder="Short Value "
                               id="CurrentSaveCodedValuesRequest.ShortValue"
                               [(ngModel)]="CurrentSaveCodedValuesRequest.ShortValue" required
                               name="CurrentSaveCodedValuesRequest.ShortValue" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                               maxlength="100" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <button type="submit" class="btn font-size-13px actions-btn-prime margin-left-auto margin-right-auto">Save</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
